import React, { useEffect, useRef, useState } from "react";
import Esign from "../Esign";
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getexternaldocuments, getSavedOfferDetails, sellerpropertydisclosure } from "../../../../api/transaction";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
import Sellerextra from "./Sellerextra";
const SellerPdf = () => {
  const componentRef = useRef();
  const { id, user }: any = useParams()
  const [loader, setloading] = useState(false)
  const [sellerdata, setSellerData] = useState({

    offer_id: id,
    property_year: 2024,
    isseller_currently_property: true,
    seller_occupied_property_year: 2024,
    isseller_ever_occupied_property: true,
    fromyear: 2020,
    toyear: 2024,
    propert_located_at: "",
    city_of: "",
    country_of: "",
    legally_discribed_as: "",
    refrigerator_lst: "",
    clothes_dryer_lst: "",
    clothes_washer_lst: "",
    dishwasher_lst: "",
    garbagedisposal_lst: "",
    freezer_lst: "",
    oven_lst: "",
    range_lst: "",
    cooktop_lst: "",
    microwave_oven_lst: "",
    vaccum_system_lst: "",
    ventilation_system_lst: "",
    gas_grill_lst: "",
    air_conditioner_lst: "",
    tv_antenna_lst: "",
    trash_compactor_lst: "",
    electrical_lst: "",
    electrical_panel_capacity: "",
    electrical_knows: false,
    electrical_fuse: false,
    ceiling_lst: "",
    ceiling_fan_number: "",
    garbage_opener_lst: "",
    garbage_door_opener_number: "",
    garbage_remote_lst: "",
    garbage_door_remote_number: "",
    garbage_keypad_lst: "",
    garbage_door_keypad_number: "",
    telephone_wiring_lst: "",
    tv_wiring_lst: "",
    intercorn_sound_system_lst: "",
    built_system_lst: "",
    smoke_detector_lst: "",
    smoke_detector_no: "",
    fire_alarm_lst: "",
    carbon_monoxide_lst: "",
    carbon_monoxide_no: "",
    room_ventilation_lst: "",
    room_ventilation_no: "",
    volt_service_lst: "",
    volt_service_no: "",
    security_system_lst: "",
    is_security_system: false,
    is_security_owned: false,
    is_security_leased: false,
    is_security_experienced: false,
    air_purified_lst: "",
    attic_fan_lst: "",
    whole_house_fan_lst: "",
    central_air_conditioning_lst: "",
    air_conditioning_year: "",
    heating_system_lst: "",
    heating_system_year: "",
    heating_system_gas: false,
    heating_system_electric: false,
    heating_system_other: false,
    heating_system_specify: "",
    fireplace_insert_lst: "",
    gas_log_fireplace_lst: "",
    gas_starter_fireplace_lst: "",
    heat_pump_lst: "",
    heat_pump_year: "",
    humidifier_lst: "",
    propane_tank_lst: "",
    propane_tank_year: "",
    propane_tank_rent: false,
    propane_tank_own: false,
    wood_burning_lst: "",
    wood_burning_stove_year: "",
    hot_tub_whirlpool_lst: "",
    plumbing_lst: "",
    swimming_pool_lst: "",
    underground_sprinkler_lst: "",
    back_flow_prevention_lst: "",
    water_heater_lst: "",
    water_heater_year: "",
    water_purifier_lst: "",
    water_purifier_year: "",
    water_softener_lst: "",
    water_softener_rent: false,
    well_system_lst: "",
    water_softener_own: false,
    plumbing_water_lst: "",
    sump_pump_lst: "",
    sump_pump_dischargeto: "",
    septic_system_lst: "",
    part2_1_lst: "",
    part2_2_lst: "",
    part2_3_lst: "",
    part2_4_lst: "",
    part2_5_lst: "",
    part2_6_lst: "",
    part2_7_lst: "",
    part2_8_lst: "",
    part2_9_lst: "",
    age_of_proof_year: "",
    age_of_proof_lst: "",
    property_year_built: "",
    property_year_sectiona_lst: "",
    part2_foundation_lst: "",
    part2_floor_lst: "",
    part2_wall_lst: "",
    part2_sidewalk_lst: "",
    part2_patio_lst: "",
    part2_driveway_lst: "",
    part2_retaining_wall_lst: "",
    part2_any_room_additions: "",
    section_b_1_lst: "",
    section_b_2_lst: "",
    section_b_3_lst: "",
    section_b_4_lst: "",
    section_b_5_lst: "",
    section_b_6_lst: "",
    section_b_7_lst: "",
    section_b_8_lst: "",
    section_b_9_lst: "",
    section_c_1_lst: "",
    section_c_2_lst: "",
    section_c_3_lst: "",
    section_c_4_lst: "",
    section_c_5_lst: "",
    section_c_6_lst: "",
    section_c_7_lst: "",
    section_c_8_lst: "",
    section_c_9_lst: "",
    section_c_10_lst: "",
    section_c_11_1_lst: "",
    section_c_11_2_lst: "",
    section_c_12_lst: "",
    section_c_13_lst: "",
    section_c_14_lst: "",
    section_c_15_lst: "",
    section_c_16_lst: "",
    section_c_17_lst: "",
    section_c_18_lst: "",
    section_d_1_1_lst: "",
    section_d_1_2_lst: "",
    section_d_2_1_lst: "",
    section_d_2_2_lst: "",
    section_d_3_lst: "",
    section_d_4_1_lst: "",
    section_d_4_2_lst: "",
    section_d_5_1_lst: "",
    section_d_5_2_lst: "",
    section_d_6_1_lst: "",
    section_d_6_2_lst: "",
    section_d_7_lst: "",
    section_d_8_1_lst: "",
    section_d_8_2_lst: "",
    section_d_9_lst: "",
    section_d_9_1: true,
    section_d_9_2: true,
    section_d_10_lst: "",
    section_d_10_1: "",
    section_d_11_lst: "",
    section_d_12_lst: "",
    section_d_12_1: "",
    section_d_13_lst: "",
    section_d_14_lst: "",
    section_d_15_1_lst: "",
    section_d_15_2_lst: "",
    section_d_16_lst: "",
    section_e_1_lst: "",
    section_e_2_lst: "",
    section_e_3_lst: "",
    section_e_4_lst: "",
    section_e_5_lst: "",
    section_e_6_lst: "",
    section_e_7_lst: "",
    section_e_8_lst: "",
    section_e_9_lst: "",
    section_e_10_lst: "",
    section_e_11_lst: "",
    seller_initial: "",
    property_address: "",
    buyer_initial: "",
    comments: "",
    checked_here: false,
    consist_of: "",
    seller1_signature: "",
    seller1_date: "",
    seller2_signature: "",
    seller2_date: "",
    purchaser1_signature: "",
    purchaser2_signature: "",
    purchaser1_date: "",
    purchaser2_date: ""

  })  // @ts-ignore
  const val = useSelector((state) => state?.new?.signset)
  const [canvasmodal, setCanvasModal] = useToggle(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [offerdetails, setOfferDetails] = useState({});
  const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid: "",
    document_name: "",
    image_base64: "",
    sign_role: 1
  })
  const ref = useRef(null)


  const printf = () => {
    handlePrint()
  };

  useEffect(()=>{
    if(val){
        if(user == "seller"){
          setSellerData({ ...sellerdata, seller1_signature: val })
        }
        if(user == "client"){
          setSellerData({ ...sellerdata, purchaser1_signature: val })
        }
    }
    },[val])

  const send = async () => {
    setloading(true)

    if (user == "seller") {
      if (sellerdata?.seller1_signature) {

        let res = await sellerpropertydisclosure(sellerdata)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    else if (user == "client") {

      if (sellerdata?.purchaser1_signature) {
        let res = await sellerpropertydisclosure(sellerdata)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    setloading(false)
  }
  useEffect(() => {
    (async function () {

      let offerdetails = await getSavedOfferDetails(id)

      setOfferDetails(offerdetails[0])
      setSellerData({ ...sellerdata, propert_located_at: offerdetails[0]?.propertyAddress })
      const res = await getexternaldocuments(id, "sellerpropertydisclosure")

      try {
        setSellerData({
          ...sellerdata,
          property_year: res?.data?.property_year,
          isseller_currently_property: res?.data?.isseller_currently_property,
          seller_occupied_property_year: res?.data?.seller_occupied_property_year,
          isseller_ever_occupied_property: res?.data?.isseller_ever_occupied_property,
          fromyear: res?.data?.fromyear,
          toyear: res?.data?.toyear,
          city_of: res?.data?.city_of,
          country_of: res?.data?.country_of,
          legally_discribed_as: res?.data?.legally_discribed_as,
          refrigerator_lst: res?.data?.refrigerator_lst,
          clothes_dryer_lst: res?.data?.clothes_dryer_lst,
          clothes_washer_lst: res?.data?.clothes_washer_lst,
          dishwasher_lst: res?.data?.dishwasher_lst,
          garbagedisposal_lst: res?.data?.garbagedisposal_lst,
          freezer_lst: res?.data?.freezer_lst,
          oven_lst: res?.data?.oven_lst,
          range_lst: res?.data?.range_lst,
          cooktop_lst: res?.data?.cooktop_lst,
          microwave_oven_lst: res?.data?.microwave_oven_lst,
          vaccum_system_lst: res?.data?.vaccum_system_lst,
          ventilation_system_lst: res?.data?.ventilation_system_lst,
          gas_grill_lst: res?.data?.gas_grill_lst,
          air_conditioner_lst: res?.data?.air_conditioner_lst,
          tv_antenna_lst: res?.data?.tv_antenna_lst,
          trash_compactor_lst: res?.data?.trash_compactor_lst,
          electrical_lst: res?.data?.electrical_lst,
          electrical_panel_capacity: res?.data?.electrical_panel_capacity,
          electrical_knows: res?.data?.electrical_knows,
          electrical_fuse: res?.data?.electrical_fuse,
          ceiling_lst: res?.data?.ceiling_lst,
          ceiling_fan_number: res?.data?.ceiling_fan_number,
          garbage_opener_lst: res?.data?.garbage_opener_lst,
          garbage_door_opener_number: res?.data?.garbage_door_opener_number,
          garbage_remote_lst: res?.data?.garbage_remote_lst,
          garbage_door_remote_number: res?.data?.garbage_door_remote_number,
          garbage_keypad_lst: res?.data?.garbage_keypad_lst,
          garbage_door_keypad_number: res?.data?.garbage_door_keypad_number,
          telephone_wiring_lst: res?.data?.telephone_wiring_lst,
          tv_wiring_lst: res?.data?.tv_wiring_lst,
          intercorn_sound_system_lst: res?.data?.intercorn_sound_system_lst,
          built_system_lst: res?.data?.built_system_lst,
          smoke_detector_lst: res?.data?.smoke_detector_lst,
          smoke_detector_no: res?.data?.smoke_detector_no,
          fire_alarm_lst: res?.data?.fire_alarm_lst,
          carbon_monoxide_lst: res?.data?.carbon_monoxide_lst,
          carbon_monoxide_no: res?.data?.carbon_monoxide_no,
          room_ventilation_lst: res?.data?.room_ventilation_lst,
          room_ventilation_no: res?.data?.room_ventilation_no,
          volt_service_lst: res?.data?.volt_service_lst,
          volt_service_no: res?.data?.volt_service_no,
          security_system_lst: res?.data?.security_system_lst,
          is_security_system: res?.data?.is_security_system,
          is_security_owned: res?.data?.is_security_owned,
          is_security_leased: res?.data?.is_security_leased,
          is_security_experienced: res?.data?.is_security_experienced,
          air_purified_lst: res?.data?.air_purified_lst,
          attic_fan_lst: res?.data?.attic_fan_lst,
          whole_house_fan_lst: res?.data?.whole_house_fan_lst,
          central_air_conditioning_lst: res?.data?.central_air_conditioning_lst,
          air_conditioning_year: res?.data?.air_conditioning_year,
          heating_system_lst: res?.data?.heating_system_lst,
          heating_system_year: res?.data?.heating_system_year,
          heating_system_gas: res?.data?.heating_system_gas,
          heating_system_electric: res?.data?.heating_system_electric,
          heating_system_other: res?.data?.heating_system_other,
          heating_system_specify: res?.data?.heating_system_specify,
          fireplace_insert_lst: res?.data?.fireplace_insert_lst,
          gas_log_fireplace_lst: res?.data?.gas_log_fireplace_lst,
          gas_starter_fireplace_lst: res?.data?.gas_starter_fireplace_lst,
          heat_pump_lst: res?.data?.heat_pump_lst,
          heat_pump_year: res?.data?.heat_pump_year,
          humidifier_lst: res?.data?.humidifier_lst,
          propane_tank_lst: res?.data?.propane_tank_lst,
          propane_tank_year: res?.data?.propane_tank_year,
          propane_tank_rent: res?.data?.propane_tank_rent,
          propane_tank_own: res?.data?.propane_tank_own,
          wood_burning_lst: res?.data?.wood_burning_lst,
          wood_burning_stove_year: res?.data?.wood_burning_stove_year,
          hot_tub_whirlpool_lst: res?.data?.hot_tub_whirlpool_lst,
          plumbing_lst: res?.data?.plumbing_lst,
          swimming_pool_lst: res?.data?.swimming_pool_lst,
          underground_sprinkler_lst: res?.data?.underground_sprinkler_lst,
          back_flow_prevention_lst: res?.data?.back_flow_prevention_lst,
          water_heater_lst: res?.data?.water_heater_lst,
          water_heater_year: res?.data?.water_heater_year,
          water_purifier_lst: res?.data?.water_purifier_lst,
          water_purifier_year: res?.data?.water_purifier_year,
          water_softener_lst: res?.data?.water_softener_lst,
          water_softener_rent: res?.data?.water_softener_rent,
          well_system_lst: res?.data?.well_system_lst,
          water_softener_own: res?.data?.water_softener_own,
          plumbing_water_lst: res?.data?.plumbing_water_lst,
          sump_pump_lst: res?.data?.sump_pump_lst,
          sump_pump_dischargeto: res?.data?.sump_pump_dischargeto,
          septic_system_lst: res?.data?.septic_system_lst,
          part2_1_lst: res?.data?.part2_1_lst,
          part2_2_lst: res?.data?.part2_2_lst,
          part2_3_lst: res?.data?.part2_3_lst,
          part2_4_lst: res?.data?.part2_4_lst,
          part2_5_lst: res?.data?.part2_5_lst,
          part2_6_lst: res?.data?.part2_6_lst,
          part2_7_lst: res?.data?.part2_7_lst,
          part2_8_lst: res?.data?.part2_8_lst,
          part2_9_lst: res?.data?.part2_9_lst,
          age_of_proof_year: res?.data?.age_of_proof_year,
          age_of_proof_lst: res?.data?.age_of_proof_lst,
          property_year_built: res?.data?.property_year_built,
          property_year_sectiona_lst: res?.data?.property_year_sectiona_lst,
          part2_foundation_lst: res?.data?.part2_foundation_lst,
          part2_floor_lst: res?.data?.part2_floor_lst,
          part2_wall_lst: res?.data?.part2_wall_lst,
          part2_sidewalk_lst: res?.data?.part2_sidewalk_lst,
          part2_patio_lst: res?.data?.part2_patio_lst,
          part2_driveway_lst: res?.data?.part2_driveway_lst,
          part2_retaining_wall_lst: res?.data?.part2_retaining_wall_lst,
          part2_any_room_additions: res?.data?.part2_any_room_additions,
          section_b_1_lst: res?.data?.section_b_1_lst,
          section_b_2_lst: res?.data?.section_b_2_lst,
          section_b_3_lst: res?.data?.section_b_3_lst,
          section_b_4_lst: res?.data?.section_b_4_lst,
          section_b_5_lst: res?.data?.section_b_5_lst,
          section_b_6_lst: res?.data?.section_b_6_lst,
          section_b_7_lst: res?.data?.section_b_7_lst,
          section_b_8_lst: res?.data?.section_b_8_lst,
          section_b_9_lst: res?.data?.section_b_9_lst,
          section_c_1_lst: res?.data?.section_c_1_lst,
          section_c_2_lst: res?.data?.section_c_2_lst,
          section_c_3_lst: res?.data?.section_c_3_lst,
          section_c_4_lst: res?.data?.section_c_4_lst,
          section_c_5_lst: res?.data?.section_c_5_lst,
          section_c_6_lst: res?.data?.section_c_6_lst,
          section_c_7_lst: res?.data?.section_c_7_lst,
          section_c_8_lst: res?.data?.section_c_8_lst,
          section_c_9_lst: res?.data?.section_c_9_lst,
          section_c_10_lst: res?.data?.section_c_10_lst,
          section_c_11_1_lst: res?.data?.section_c_11_1_lst,
          section_c_11_2_lst: res?.data?.section_c_11_2_lst,
          section_c_12_lst: res?.data?.section_c_12_lst,
          section_c_13_lst: res?.data?.section_c_13_lst,
          section_c_14_lst: res?.data?.section_c_14_lst,
          section_c_15_lst: res?.data?.section_c_15_lst,
          section_c_16_lst: res?.data?.section_c_16_lst,
          section_c_17_lst: res?.data?.section_c_17_lst,
          section_c_18_lst: res?.data?.section_c_18_lst,
          section_d_1_1_lst: res?.data?.section_d_1_1_lst,
          section_d_1_2_lst: res?.data?.section_d_1_2_lst,
          section_d_2_1_lst: res?.data?.section_d_2_1_lst,
          section_d_2_2_lst: res?.data?.section_d_2_2_lst,
          section_d_3_lst: res?.data?.section_d_3_lst,
          section_d_4_1_lst: res?.data?.section_d_4_1_lst,
          section_d_4_2_lst: res?.data?.section_d_4_2_lst,
          section_d_5_1_lst: res?.data?.section_d_5_1_lst,
          section_d_5_2_lst: res?.data?.section_d_5_2_lst,
          section_d_6_1_lst: res?.data?.section_d_6_1_lst,
          section_d_6_2_lst: res?.data?.section_d_6_2_lst,
          section_d_7_lst: res?.data?.section_d_7_lst,
          section_d_8_1_lst: res?.data?.section_d_8_1_lst,
          section_d_8_2_lst: res?.data?.section_d_8_2_lst,
          section_d_9_lst: res?.data?.section_d_9_lst,
          section_d_9_1: res?.data?.section_d_9_1,
          section_d_9_2: res?.data?.section_d_9_2,
          section_d_10_lst: res?.data?.section_d_10_lst,
          section_d_10_1: res?.data?.section_d_10_1,
          section_d_11_lst: res?.data?.section_d_11_lst,
          section_d_12_lst: res?.data?.section_d_12_lst,
          section_d_12_1: res?.data?.section_d_12_1,
          section_d_13_lst: res?.data?.section_d_13_lst,
          section_d_14_lst: res?.data?.section_d_14_lst,
          section_d_15_1_lst: res?.data?.section_d_15_1_lst,
          section_d_15_2_lst: res?.data?.section_d_15_2_lst,
          section_d_16_lst: res?.data?.section_d_16_lst,
          section_e_1_lst: res?.data?.section_e_1_lst,
          section_e_2_lst: res?.data?.section_e_2_lst,
          section_e_3_lst: res?.data?.section_e_3_lst,
          section_e_4_lst: res?.data?.section_e_4_lst,
          section_e_5_lst: res?.data?.section_e_5_lst,
          section_e_6_lst: res?.data?.section_e_6_lst,
          section_e_7_lst: res?.data?.section_e_7_lst,
          section_e_8_lst: res?.data?.section_e_8_lst,
          section_e_9_lst: res?.data?.section_e_9_lst,
          section_e_10_lst: res?.data?.section_e_10_lst,
          section_e_11_lst: res?.data?.section_e_11_lst,
          seller_initial: res?.data?.seller_initial,
          property_address: res?.data?.property_address,
          buyer_initial: res?.data?.buyer_initial,
          comments: res?.data?.comments,
          checked_here: res?.data?.checked_here,
          consist_of: res?.data?.consist_of,
          seller1_signature: res?.data?.seller1_signature,
          seller1_date: res?.data?.seller1_date,
          seller2_signature: res?.data?.seller2_signature,
          seller2_date: res?.data?.seller2_date,
          purchaser1_signature: res?.data?.purchaser1_signature,
          purchaser2_signature: res?.data?.purchaser2_signature,
          purchaser1_date: res?.data?.purchaser1_date,
          purchaser2_date: res?.data?.purchaser2_date
        })
      } catch (error) {
        console.log(error);
      }


    })()

  }, [])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <div ref={componentRef} >
        <section style={{ pageBreakAfter: "always" }}>
          <table
            style={{
              width: 1100,
              margin: "0 auto",
              background: "#fff",
              padding: "10px 15px"
            }}
          >
            <tbody>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "20%" }}>
                          <img
                            style={{ width: "100%" }}
                            src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            width: "33%"
                          }}
                        >
                          NEBRASKA REAL ESTATE COMMISSION <br />
                          SELLER PROPERTY CONDITION DISCLOSURE STATEMENT
                          <br />
                          Residential Real Property
                        </td>
                        <td style={{ width: "20%" }}>
                          <img
                            style={{ width: "100%" }}
                            src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                            alt=""
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      THIS DISCLOSURE STATEMENT IS BEING COMPLETED AND DELIVERED IN
                      ACCORDANCE WITH NEBRASKA LAW. NEBRASKA LAW REQUIRES THE SELLER
                      TO COMPLETE THIS STATEMENT (NEB. REV. STAT. §76-2,120).{" "}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ border: "1px solid black", padding: 5 }}>
                    <span>
                      How long has the seller owned the property?
                      <input
                        type="number"
                        maxLength={4}
                        value={sellerdata?.property_year}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length > 4) {
                            // Limit the input value to 4 characters
                            e.target.value = value.substring(0, 4);
                          }  // @ts-ignore
                          setSellerData({ ...sellerdata, property_year: e.target.value });
                        }}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      year(s)
                      <br /> Is seller currently occupying the property?{" "}
                      <input type="checkbox" checked={sellerdata?.isseller_currently_property === true ? true : false} onChange={() => { setSellerData({ ...sellerdata, isseller_currently_property: !sellerdata?.isseller_currently_property }) }} /> YES
                      <input type="checkbox" checked={sellerdata?.isseller_currently_property === false ? true : false} onChange={() => { setSellerData({ ...sellerdata, isseller_currently_property: !sellerdata?.isseller_currently_property }) }} />
                      NO If yes, how long has the seller occupied the property?{" "}
                      <input
                        type="number"
                        maxLength={4}
                        value={sellerdata?.seller_occupied_property_year}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length > 4) {
                            // Limit the input value to 4 characters
                            e.target.value = value.substring(0, 4);
                          }
                          // @ts-ignore
                          setSellerData({ ...sellerdata, seller_occupied_property_year: e.target.value });
                        }}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      year(s) If no, has <br />
                      the seller ever occupied the property?
                      <input type="checkbox" checked={sellerdata?.isseller_ever_occupied_property === true ? true : false} onChange={() => { setSellerData({ ...sellerdata, isseller_ever_occupied_property: !sellerdata?.isseller_ever_occupied_property }) }} /> YES
                      <input type="checkbox" checked={sellerdata?.isseller_ever_occupied_property === false ? true : false} onChange={() => { setSellerData({ ...sellerdata, isseller_ever_occupied_property: !sellerdata?.isseller_ever_occupied_property }) }} />
                      NO If yes, when? From{" "}
                      <input
                        type="number"
                        maxLength={4}
                        value={sellerdata?.fromyear}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length > 4) {
                            // Limit the input value to 4 characters
                            e.target.value = value.substring(0, 4);
                          }  // @ts-ignore
                          setSellerData({ ...sellerdata, fromyear: e.target.value });
                        }}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      (year) to
                      <input
                        type="number"
                        max={4}
                        maxLength={4}
                        value={sellerdata?.toyear}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length > 4) {
                            // Limit the input value to 4 characters
                            e.target.value = value.substring(0, 4);
                          }  // @ts-ignore
                          setSellerData({ ...sellerdata, toyear: e.target.value });
                        }}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      (year){" "}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      This disclosure statement concerns the real property located at{" "}
                      <input
                        type="text"//@ts-ignore
                        value={offerdetails?.propertyAddress}
                        // onChange={(e)=> setSellerData({ ...sellerdata, propert_located_at: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 900
                        }}
                      />
                      in the city of{" "}
                      <input
                        value={sellerdata?.city_of}
                        onChange={(e) => setSellerData({ ...sellerdata, city_of: e.target.value })}
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 300
                        }}
                      />
                      , County of{" "}
                      <input
                        type="text"
                        value={sellerdata?.country_of}
                        onChange={(e) => setSellerData({ ...sellerdata, country_of: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 300
                        }}
                      />
                      , State of Nebraska and legally described as:
                      <br />
                      <input
                        value={sellerdata?.legally_discribed_as}
                        onChange={(e) => setSellerData({ ...sellerdata, legally_discribed_as: e.target.value })}
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: "100%"
                        }}
                      />
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span style={{ fontWeight: 600 }}>
                      This statement is a disclosure of the condition of the real
                      property known by the seller on the date on which this statement
                      is signed. This statement is{" "}
                      <span style={{ textDecoration: "underline" }}>
                        {" "}
                        NOT a warranty of any kind{" "}
                      </span>
                      by the seller or any agent representing a principal in the
                      transaction, and{" "}
                      <span style={{ textDecoration: "underline" }}>
                        {" "}
                        should NOT be accepted as a substitute for any inspection or
                        warranty that the purchaser may wish to obtain.
                      </span>{" "}
                      Even though the information provided in this statement is NOT a
                      warranty, the purchaser may rely on the information contained
                      herein in deciding whether and on what terms to purchase the
                      real property. Any agent representing a principal in the
                      transaction may provide a copy of this statement to any other
                      person in connection with any actual or possible sale of the
                      real property. The information provided in this statement is the
                      representation of the seller and NOT the representation of any
                      agent, and is NOT intended to be part of any contract between
                      the seller and purchaser.{" "}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ border: "1px solid black" }}>
                    <span>
                      Seller please note: you are required to complete this disclosure
                      statement IN FULL. If any particular item or matter does not
                      apply and there is no provision or space for indicating, insert
                      “N/A” in the appropriate box. If age of items is unknown, write
                      “UNK” on the blank provided. If the property has more than one
                      item as listed below please put the numbered in the appropriate
                      box. For example – if the home has three room air conditioners,
                      one working, one not working, and one not included, put a “1” in
                      each of the “Working”, “Not Working”, and “None/Not Included”
                      boxes for that item, and a “3” on the line provided next to the
                      item description to indicate total number of item. You may also
                      provide additional explanation of any item in the comments
                      section in PART III.
                    </span>
                  </div>
                  <div style={{ border: "1px solid black" }}>
                    <span style={{ fontWeight: 600 }}>
                      SELLER STATES THAT, TO THE BEST OF THE SELLER’S KNOWLEDGE AS OF
                      THE DATE THIS DISCLOSURE STATEMENT IS COMPLETED AND SIGNED BY
                      THE SELLER, THE CONDITION OF THE REAL PROPERTY IS:
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span>
                    <span style={{ fontWeight: 600 }}>PART I –</span> If there is more
                    than one of any item in this Part, the statement made applies to
                    each and all of such items unless otherwise noted in the Comments
                    section in PART III of this disclosure statement, or number
                    separately as provided in the instructions above. If an item in
                    this Part is not on the property, or will not be included in the
                    sale, check only the “None/Not included” column for that item.{" "}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={7}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section A -Appliances
                                </th>
                                <th style={{ fontWeight: 600 }}>Working</th>
                                <th style={{ fontWeight: 600 }}>
                                  Not
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  Do Not
                                  <br />
                                  Know If
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  None /<br />
                                  Not
                                  <br />
                                  Included
                                  <br />
                                </th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>1. Refrigerator</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.refrigerator_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, refrigerator_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox" checked={sellerdata?.refrigerator_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, refrigerator_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox" checked={sellerdata?.refrigerator_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, refrigerator_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox" checked={sellerdata?.refrigerator_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, refrigerator_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>2. Clothes Dryer</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_dryer_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_dryer_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_dryer_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_dryer_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_dryer_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_dryer_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_dryer_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_dryer_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>3. Clothes Washer</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_washer_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_washer_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_washer_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_washer_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_washer_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_washer_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.clothes_washer_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, clothes_washer_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>4. Dishwasher</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.dishwasher_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, dishwasher_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.dishwasher_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, dishwasher_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.dishwasher_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, dishwasher_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.dishwasher_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, dishwasher_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Garbage Disposal
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbagedisposal_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbagedisposal_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbagedisposal_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbagedisposal_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbagedisposal_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbagedisposal_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbagedisposal_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbagedisposal_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>6. Freezer</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.freezer_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, freezer_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.freezer_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, freezer_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.freezer_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, freezer_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.freezer_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, freezer_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>7. Oven</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.oven_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, oven_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.oven_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, oven_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.oven_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, oven_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.oven_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, oven_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>8. Range</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.range_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, range_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.range_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, range_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.range_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, range_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.range_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, range_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>9. Cooktop</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.cooktop_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, cooktop_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.cooktop_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, cooktop_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.cooktop_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, cooktop_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.cooktop_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, cooktop_lst: "None" }) }}
                                  />
                                </td>
                              </tr>{" "}
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  10. Microwave oven
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.microwave_oven_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, microwave_oven_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.microwave_oven_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, microwave_oven_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.microwave_oven_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, microwave_oven_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.microwave_oven_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, microwave_oven_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Built-In vacuum system and equipment
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.vaccum_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, vaccum_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.vaccum_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, vaccum_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.vaccum_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, vaccum_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.vaccum_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, vaccum_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Range ventilation systems
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ventilation_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ventilation_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ventilation_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ventilation_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ventilation_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ventilation_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ventilation_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ventilation_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>13. Gas grill</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_grill_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_grill_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_grill_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_grill_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_grill_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_grill_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_grill_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_grill_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  14. Room air conditioner ({" "}
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  number )
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_conditioner_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_conditioner_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_conditioner_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_conditioner_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_conditioner_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_conditioner_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_conditioner_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_conditioner_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  15. TV antenna / Satellite dish
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_antenna_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_antenna_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_antenna_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_antenna_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_antenna_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_antenna_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_antenna_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_antenna_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  16. Trash compactor
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.trash_compactor_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, trash_compactor_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.trash_compactor_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, trash_compactor_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.trash_compactor_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, trash_compactor_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.trash_compactor_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, trash_compactor_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%" }}>
                          <table
                            // border={1}
                            cellPadding={2}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section B - Electrical Systems
                                </th>
                                <th style={{ fontWeight: 600 }}>Working</th>
                                <th style={{ fontWeight: 600 }}>
                                  Not
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  Do Not
                                  <br />
                                  Know If
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  None /<br />
                                  Not
                                  <br />
                                  Included
                                  <br />
                                </th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Electrical service panel Capacity
                                  <input
                                    type="text"
                                    value={sellerdata?.electrical_panel_capacity}
                                    onChange={(e) => setSellerData({ ...sellerdata, electrical_panel_capacity: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  AMP Capacity (if known)
                                  <input type="checkbox" />
                                  fuse <input type="checkbox" /> circuit breakers
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.electrical_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, electrical_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.electrical_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, electrical_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.electrical_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, electrical_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.electrical_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, electrical_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  2. Ceiling fan(s) (
                                  <input
                                    type="text"
                                    value={sellerdata?.ceiling_fan_number}
                                    onChange={(e) => setSellerData({ ...sellerdata, ceiling_fan_number: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number){" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ceiling_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ceiling_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ceiling_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ceiling_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ceiling_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ceiling_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.ceiling_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, ceiling_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. Garage door opener(s) (
                                  <input
                                    type="text"
                                    value={sellerdata?.garbage_door_opener_number}
                                    onChange={(e) => setSellerData({ ...sellerdata, garbage_door_opener_number: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number){" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_opener_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_opener_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_opener_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_opener_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_opener_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_opener_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_opener_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_opener_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Garage door remote(s) (
                                  <input
                                    type="text"
                                    value={sellerdata?.garbage_door_remote_number}
                                    onChange={(e) => setSellerData({ ...sellerdata, garbage_door_remote_number: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_remote_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_remote_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_remote_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_remote_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_remote_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_remote_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_remote_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_remote_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Garage door keypad(s) (
                                  <input
                                    type="text"
                                    value={sellerdata?.garbage_door_keypad_number}
                                    onChange={(e) => setSellerData({ ...sellerdata, garbage_door_keypad_number: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_keypad_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_keypad_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_keypad_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_keypad_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_keypad_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_keypad_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.garbage_keypad_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, garbage_keypad_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Telephone wiring and jacks
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.telephone_wiring_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, telephone_wiring_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.telephone_wiring_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, telephone_wiring_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.telephone_wiring_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, telephone_wiring_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.telephone_wiring_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, telephone_wiring_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Cable TV wiring and jacks
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_wiring_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_wiring_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_wiring_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_wiring_lst: "Not_Working" }) }} />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_wiring_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_wiring_lst: "Do_Not_Know_If_Working" }) }} />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.tv_wiring_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, tv_wiring_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Intercom or sound system wiring
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.intercorn_sound_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, intercorn_sound_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.intercorn_sound_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, intercorn_sound_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.intercorn_sound_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, intercorn_sound_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.intercorn_sound_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, intercorn_sound_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  9. Built-In speakers
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.built_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, built_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.built_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, built_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.built_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, built_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.built_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, built_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>{" "}
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  10. Smoke detectors (
                                  <input
                                    type="text"
                                    value={sellerdata?.smoke_detector_no}
                                    onChange={(e) => setSellerData({ ...sellerdata, smoke_detector_no: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number){" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.smoke_detector_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, smoke_detector_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.smoke_detector_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, smoke_detector_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.smoke_detector_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, smoke_detector_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.smoke_detector_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, smoke_detector_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>11. Fire alarm</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fire_alarm_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fire_alarm_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fire_alarm_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fire_alarm_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fire_alarm_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fire_alarm_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fire_alarm_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fire_alarm_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Carbon Monoxide Alarm (
                                  <input
                                    type="text"
                                    value={sellerdata?.carbon_monoxide_no}
                                    onChange={(e) => setSellerData({ ...sellerdata, carbon_monoxide_no: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.carbon_monoxide_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, carbon_monoxide_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.carbon_monoxide_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, carbon_monoxide_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.carbon_monoxide_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, carbon_monoxide_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.carbon_monoxide_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, carbon_monoxide_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  13. Room ventilation/exhaust fan (
                                  <input
                                    type="text"
                                    value={sellerdata?.room_ventilation_no}
                                    onChange={(e) => setSellerData({ ...sellerdata, room_ventilation_no: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  number)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.room_ventilation_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, room_ventilation_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.room_ventilation_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, room_ventilation_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.room_ventilation_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, room_ventilation_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.room_ventilation_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, room_ventilation_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  14. 220 volt service ({" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.volt_service_no}
                                    onChange={(e) => setSellerData({ ...sellerdata, volt_service_no: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  number )
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.volt_service_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, volt_service_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.volt_service_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, volt_service_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.volt_service_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, volt_service_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.volt_service_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, volt_service_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  15. Security System <input type="checkbox" checked={sellerdata?.is_security_system}
                                    onChange={() => setSellerData({ ...sellerdata, is_security_system: !sellerdata.is_security_system })}
                                  /> Owned{" "}
                                  <input type="checkbox" checked={sellerdata?.is_security_owned}
                                    onChange={() => { setSellerData({ ...sellerdata, is_security_owned: !sellerdata?.is_security_owned }) }}
                                  /> Leased{" "}
                                  <input type="checkbox" checked={sellerdata?.is_security_leased}
                                    onChange={() => { setSellerData({ ...sellerdata, is_security_leased: !sellerdata?.is_security_leased }) }}
                                  /> Central station monitoring{" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.security_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, security_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.security_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, security_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.security_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, security_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.security_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, security_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  16. Have you experienced any problems with the
                                  electrical system or its components?
                                  <input type="checkbox" checked={sellerdata?.is_security_experienced}
                                    onChange={() => { setSellerData({ ...sellerdata, is_security_experienced: !sellerdata?.is_security_experienced }) }}
                                  /> YES{" "}
                                  <input type="checkbox" checked={sellerdata?.is_security_experienced === true ? false : true}
                                    onChange={() => { setSellerData({ ...sellerdata, is_security_experienced: !sellerdata?.is_security_experienced }) }}
                                  /> NO
                                </td>
                                <td colSpan={4} style={{ fontWeight: 600 }}>
                                  {" "}
                                  If YES, explain the condition in the comments
                                  section in PART III of this disclosure statement.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span style={{ fontWeight: 600 }}>
                      <span style={{ fontWeight: 700 }}>Seller’s Initials</span>
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />{" "}
                      Property Address{" "}
                      <input
                        type="text" //@ts-ignore
                        value={offerdetails?.propertyAddress}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 400
                        }}
                      />
                      Buyer’s Initials
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <table
            style={{
              width: 1100,
              margin: "0 auto",
              background: "#fff",
              padding: "10px 15px"
            }}
          >
            <tbody>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={6}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  ection C - Heating and Cooling Systems
                                </th>
                                <th style={{ fontWeight: 600 }}>Working</th>
                                <th style={{ fontWeight: 600 }}>
                                  Not
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  Do Not
                                  <br />
                                  Know If
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  None /<br />
                                  Not
                                  <br />
                                  Included
                                  <br />
                                </th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}> 1. Air purifier</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_purified_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_purified_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_purified_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_purified_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_purified_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_purified_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.air_purified_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, air_purified_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}> 2. Attic fan</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.attic_fan_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, attic_fan_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.attic_fan_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, attic_fan_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.attic_fan_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, attic_fan_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.attic_fan_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, attic_fan_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. Whole house fan
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.whole_house_fan_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, whole_house_fan_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.whole_house_fan_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, whole_house_fan_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.whole_house_fan_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, whole_house_fan_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.whole_house_fan_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, whole_house_fan_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Central air conditioning{" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.air_conditioning_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, air_conditioning_year: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.central_air_conditioning_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, central_air_conditioning_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.central_air_conditioning_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, central_air_conditioning_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.central_air_conditioning_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, central_air_conditioning_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.central_air_conditioning_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, central_air_conditioning_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Heating system{" "}
                                  <input
                                    value={sellerdata?.heating_system_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, heating_system_year: e.target.value })}
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known) <input type="checkbox"
                                    checked={sellerdata?.heating_system_gas}
                                    onChange={(e) => setSellerData({ ...sellerdata, heating_system_gas: !sellerdata?.heating_system_gas })}
                                  />{" "}
                                  Gas <input type="checkbox"
                                    checked={sellerdata?.heating_system_electric}
                                    onChange={(e) => setSellerData({ ...sellerdata, heating_system_electric: !sellerdata?.heating_system_electric })}
                                  /> Electric{" "}
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_other}
                                    onChange={(e) => setSellerData({ ...sellerdata, heating_system_other: !sellerdata?.heating_system_other })}
                                  />
                                  Other (specify{" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.heating_system_specify}
                                    onChange={(e) => setSellerData({ ...sellerdata, heating_system_specify: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  )
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heating_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heating_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heating_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heating_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Fireplace / Fireplace Insert
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fireplace_insert_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fireplace_insert_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fireplace_insert_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fireplace_insert_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fireplace_insert_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fireplace_insert_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.fireplace_insert_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, fireplace_insert_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Gas log (fireplace)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_log_fireplace_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_log_fireplace_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_log_fireplace_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_log_fireplace_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_log_fireplace_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_log_fireplace_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heating_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heating_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Gas starter (fireplace)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_starter_fireplace_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_starter_fireplace_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_starter_fireplace_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_starter_fireplace_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_starter_fireplace_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_starter_fireplace_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.gas_starter_fireplace_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, gas_starter_fireplace_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  9. Heat pump{" "}
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heat_pump_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heat_pump_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heat_pump_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heat_pump_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heat_pump_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heat_pump_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.heat_pump_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, heat_pump_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>10. Humidifier</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.humidifier_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, humidifier_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.humidifier_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, humidifier_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.humidifier_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, humidifier_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.humidifier_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, humidifier_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Propane Tank{" "}
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />{" "}
                                  year installed (if known)
                                  <input type="checkbox"
                                    checked={sellerdata?.propane_tank_rent}
                                    onChange={() => setSellerData({ ...sellerdata, propane_tank_rent: !sellerdata?.propane_tank_rent })}
                                  />
                                  Rent <input type="checkbox"
                                    checked={sellerdata?.propane_tank_own}
                                    onChange={() => setSellerData({ ...sellerdata, propane_tank_own: !sellerdata?.propane_tank_own })}
                                  />
                                  Own
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.propane_tank_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, propane_tank_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.propane_tank_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, propane_tank_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.propane_tank_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, propane_tank_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.propane_tank_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, propane_tank_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Wood-burning stove{" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.wood_burning_stove_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, wood_burning_stove_year: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.wood_burning_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, wood_burning_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.wood_burning_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, wood_burning_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.wood_burning_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, wood_burning_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.wood_burning_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, wood_burning_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "top" }}>
                          <table
                            // border={1}
                            cellPadding={5}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section D - Water Systems
                                </th>
                                <th style={{ fontWeight: 600 }}>Working</th>
                                <th style={{ fontWeight: 600 }}>
                                  Not
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  Do Not
                                  <br />
                                  Know If
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  None /<br />
                                  Not
                                  <br />
                                  Included
                                  <br />
                                </th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Hot tub / whirlpool
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.hot_tub_whirlpool_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, hot_tub_whirlpool_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.hot_tub_whirlpool_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, hot_tub_whirlpool_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.hot_tub_whirlpool_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, hot_tub_whirlpool_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.hot_tub_whirlpool_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, hot_tub_whirlpool_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  2. Plumbing (water supply)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>3. Swimming pool</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.swimming_pool_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, swimming_pool_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.swimming_pool_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, swimming_pool_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.swimming_pool_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, swimming_pool_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.swimming_pool_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, swimming_pool_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. a. Underground sprinkler system{" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.underground_sprinkler_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, underground_sprinkler_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.underground_sprinkler_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, underground_sprinkler_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.underground_sprinkler_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, underground_sprinkler_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.underground_sprinkler_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, underground_sprinkler_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Back-flow prevention system
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.back_flow_prevention_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, back_flow_prevention_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.back_flow_prevention_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, back_flow_prevention_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.back_flow_prevention_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, back_flow_prevention_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.back_flow_prevention_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, back_flow_prevention_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Water heater{" "}
                                  <input
                                    value={sellerdata?.water_heater_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, water_heater_year: e.target.value })}
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_heater_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_heater_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_heater_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_heater_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_heater_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_heater_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_heater_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_heater_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Water purifier
                                  <input
                                    type="text"
                                    value={sellerdata?.water_purifier_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, water_purifier_year: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year installed (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_purifier_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_purifier_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_purifier_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_purifier_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_purifier_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_purifier_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_purifier_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_purifier_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Water softener <input type="checkbox"
                                    checked={sellerdata?.water_softener_rent}
                                    onChange={() => setSellerData({ ...sellerdata, water_softener_rent: !sellerdata?.water_softener_rent })}
                                  /> Rent{" "}
                                  <input type="checkbox"
                                    checked={sellerdata?.water_softener_own}
                                    onChange={() => setSellerData({ ...sellerdata, water_softener_own: !sellerdata?.water_softener_own })}
                                  />
                                  own
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_softener_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_softener_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_softener_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_softener_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_softener_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_softener_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.water_softener_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, water_softener_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>8. Well system</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.well_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, well_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.well_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, well_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.well_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, well_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.well_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, well_system_lst: "Working" }) }}
                                  />
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                          <table
                            // border={1}
                            cellPadding={6}
                            cellSpacing={0}
                            style={{ width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th>Section E - Sewer Systems</th>
                                <th style={{ fontWeight: 600 }}>Working</th>
                                <th style={{ fontWeight: 600 }}>
                                  Not
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  Do Not
                                  <br />
                                  Know If
                                  <br />
                                  Working
                                </th>
                                <th style={{ fontWeight: 600 }}>
                                  None /<br />
                                  Not
                                  <br />
                                  Included
                                  <br />
                                </th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Plumbing (water drainage)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_water_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_water_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_water_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_water_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_water_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.plumbing_water_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, plumbing_water_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  2. Sump pump (discharges to{" "}
                                  <input
                                    value={sellerdata?.sump_pump_dischargeto}
                                    onChange={(e) => setSellerData({ ...sellerdata, sump_pump_dischargeto: e.target.value })}
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  )
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.sump_pump_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, sump_pump_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.sump_pump_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, sump_pump_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.sump_pump_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, sump_pump_lst: "None" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.sump_pump_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, sump_pump_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>3. Septic System</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.septic_system_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, septic_system_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.septic_system_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, septic_system_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.septic_system_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, septic_system_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.septic_system_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, septic_system_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>PART II -</span>
                      In Sections A, B, C, and D if the answer to any item is “YES”,
                      explain the condition in the comments Section in PART III of
                      this disclosure statement.
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>
                        Section A. Structural Conditions -
                      </span>
                      If there is more than one of any item listed in this Section,
                      the statement made applies to each and all of such items unless
                      otherwise noted in the comment section in PART III of this
                      disclosure statement.
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={4}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section A - Structural Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Age of roof (if known){" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.age_of_proof_year}
                                    onChange={(e) => setSellerData({ ...sellerdata, age_of_proof_year: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year(s)
                                </td>
                                <td>N / A </td>
                                <td>N / A</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.age_of_proof_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, age_of_proof_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {/* in progress */}

                                  2. Does the roof leak?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_2_lst: "yes" }) }} />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_2_lst: "no" }) }} />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_2_lst: "Do_Not_Know" }) }} />
                                </td>
                              </tr>
                              <tr>

                                <td style={{ fontWeight: 600 }}>
                                  3. Has the roof leaked?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_3_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_3_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_3_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_3_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_3_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_3_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Is there presently damage to the roof?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_4_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_4_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_4_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_4_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_4_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_4_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Has there been water intrusion in the basement or
                                  crawl space?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_5_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_5_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_5_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_5_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_5_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_5_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Has there been any damage to the real property or
                                  any of the structures thereon due to the following
                                  occurrences including, but not limited to, wind,
                                  hail, fire, flood, wood-destroying insects, or
                                  rodents?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_6_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_6_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_6_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_6_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_6_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_6_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Are there any structural problems with the
                                  structures on the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_7_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_7_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_7_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_7_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_7_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_7_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Is there presently damage to the chimney?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_8_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_8_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_8_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_8_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_8_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_8_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  9. Are there any windows which presently leak, or do
                                  any insulated windows have any broken seals?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_9_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_9_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_9_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_9_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_9_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_9_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "top" }}>
                          <table
                            // border={1}
                            cellPadding={4}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section A - Structural Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                            </tbody>
                            <tbody>
                              {/* <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Age of roof (if known){" "}
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  year(s)
                                </td>
                                <td>N / A </td>
                                <td>N / A</td>
                                <td>
                                  <input type="checkbox" />
                                </td>
                              </tr> */}
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  10. Year property was built{" "}
                                  <input
                                    value={sellerdata?.property_year_built}
                                    onChange={(e) => setSellerData({ ...sellerdata, property_year_built: e.target.value })}
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 50
                                    }}
                                  />
                                  (if known)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.property_year_sectiona_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, property_year_sectiona_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.property_year_sectiona_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, property_year_sectiona_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.property_year_sectiona_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, property_year_sectiona_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Has the property experienced any moving or
                                  settling of the following:
                                </td>
                                <td>---</td>
                                <td>---</td>
                                <td>---</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}> - Foundation</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_foundation_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_foundation_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_foundation_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_foundation_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_foundation_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_foundation_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>- Floor</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_floor_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_floor_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_floor_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_floor_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_floor_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_floor_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}> - Wall</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_wall_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_wall_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_wall_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_wall_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_wall_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_wall_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>- Sidewalk</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_sidewalk_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_sidewalk_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_sidewalk_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_sidewalk_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_sidewalk_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_sidewalk_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>- Patio</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_patio_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_patio_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_patio_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_patio_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_patio_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_patio_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>- Driveway</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_driveway_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_driveway_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_driveway_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_driveway_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_driveway_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_driveway_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>- Retaining wall</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_retaining_wall_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_retaining_wall_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_retaining_wall_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_retaining_wall_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_retaining_wall_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_retaining_wall_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Any room additions or structural changes?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_any_room_additions === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_any_room_additions: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_any_room_additions === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_any_room_additions: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.part2_any_room_additions === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, part2_any_room_additions: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>
                        Section B. Environmental Conditions -
                      </span>
                      Have any of the following substances, materials, or products
                      been on the real property? If tests have been conducted for any
                      of the following, provide a copy of all test results, if
                      available.
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "top" }}>
                          <table
                            // border={1}
                            cellPadding={6}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section B - Environmental Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>1. Asbestos</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_1_lst: "yes" }) }}
                                  />{" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  2. Contaminated soil or water (including drinking
                                  water){" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. Landfill or buried materials
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_3_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_3_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_3_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_3_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_3_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_3_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Lead-based paint
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_4_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_4_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_4_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_4_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_4_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_4_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>5. Radon gas</td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_5_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_5_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_5_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_5_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_5_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_5_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Toxic materials
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_6_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_6_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_6_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_6_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_6_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_6_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={6}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section B - Environmental Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Underground fuel, chemical or other type of
                                  storage tank?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_7_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_7_lst: "yes" }) }}
                                  />{" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_7_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_7_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_7_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_7_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Have you been notified by the Noxious Weed
                                  Control Authority in the last 3 years of the
                                  presence of noxious weeds, as defined by Nebraska
                                  law (N.A.C. Title 25, Ch. 10), on the property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_8_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_8_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_8_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_8_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_8_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_8_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  9. Hazardous substances, materials or products
                                  identified by the Environmental Protection Agency or
                                  its authorized Nebraska Designee (excluding ordinary
                                  household cleaners)
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_9_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_9_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_9_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_9_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_b_9_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_b_9_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ marginTop: 5 }}>
                    <span style={{ fontWeight: 600 }}>
                      <span style={{ fontWeight: 700 }}>Seller’s Initials</span>
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />{" "}
                      Property Address{" "}
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 450
                        }}
                      />
                      Buyer’s Initials
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      <Sellerextra setSellerData={setSellerData} sellerdata={sellerdata} val={val} user={user}/>
      </div>
      {
        user !== "agent" &&
        <>
          <React.Fragment>
            <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
              <button onClick={send} className="btn primaryColorBtn">Submit
                {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
              </button>
              <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
              <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
            </div>
          </React.Fragment>
          <Esign
            canvasmodal={canvasmodal}
            setCanvasModal={setCanvasModal}
            htmlContent={htmlContent}
            setHtmlContent={setHtmlContent}
            selecteddocumentesign={selecteddocumentesign}
            setselectedDocumentEsign={setselectedDocumentEsign}
            type={"seller"}
          ></Esign>
        </>
      }

    </>

  )
}

export default SellerPdf

